import PageDataType from "../../types/page.type";

const SeoDataHandler = (pageData: PageDataType | undefined) => {
  return {
    title: pageData?.data?.[0]?.attributes?.seoData?.metaTitle || "",
    description:
      pageData?.data?.[0]?.attributes?.seoData?.metaDescription || "",
    pagePath: pageData?.data?.[0]?.attributes?.url || "",
    keywords: pageData?.data?.[0]?.attributes?.seoData?.keywords || "",
    image:
      `${process.env.GATSBY_BACKEND_URL}${pageData?.data?.[0]?.attributes?.seoData?.metaImage?.media?.data?.[0]?.attributes?.url}` ||
      "",
  };
};

export default SeoDataHandler;
